import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { NotesFilterSettings } from "@/Patient/Models/Settings/NotesFilterSettings";

export class MedicalNotesConfigurationActions extends AsyncAction {
    private static readonly actions = new MedicalNotesConfigurationActions();

    public static async save(notesFilterSettings: NotesFilterSettings, userId: string): Promise<void> {
        await this.actions.postAsync(
            ServerOperations.Server.Myle_Patient_MedicalSummary_UpdateNotesFilterConfiguration,
            {
                NotesFilterSettings: notesFilterSettings,
                UserId: userId
            }
        );
    }
}
